/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'

export default function WarningModal({ image, open, title, subtitle, subtitle1 = '', subtitle2 = '', subtitle3 = '', opacity, children, width = 'sm:w-full sm:max-w-sm', bgColor = 'bg-primarioMira', isDefault = true, paddingTop = 'sm:my-8 sm:p-6 pt-5' }) {

  
    
   //useEffect(() => {
   //  console.log(image.props.src)
   //}, [])
  

  return (
    <>
      {open ?
      image?.props?.src?
      <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={() => !open}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className={`fixed inset-0 bg-secundarioMira ` + opacity + ` transition-opacity`} />
            </Transition.Child>

            <div className="fixed inset-0 z-30 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className={`z-30 relative transform overflow-hidden scale-50 rounded-lg ${bgColor}  ${paddingTop}  text-left |shadow-xltransition-all ${width}`}>
                    {
                      isDefault ?
                        <div className="">
                          <div className="flex flex-row justify-center ">
                          <div className=' w-[70%] '>
                            {image}
                          </div>
                          </div>
                          <div className="mt-3 text-center sm:mt-3">
                            <Dialog.Title as="h3" className="text-3xl font-medium leading-6 text-white">
                              {title || 
                               <>
                                <p className="text-4xl font-semibold leading-6 text-white mb-2">Cargando...</p>
                                <p className="text-4xl  font-semibold leading-6 text-white">Espere por favor.</p>
                               </>}
                            </Dialog.Title>
                            <div className="mt-2">
                              <div className="text-md text-grisMira">
                                {subtitle}
                              </div>
                              <div className="text-md text-grisMira">
                                {subtitle1}
                              </div>
                              <div className="text-md text-grisMira">
                                {subtitle2}
                              </div>
                              {subtitle3 !== ''
                                ?
                                <>
                                  <br></br>
                                  <div className="text-md text-grisMira">
                                    {subtitle3}
                                  </div>
                                </>
                                : null
                              }
                            </div>
                          </div>
                        </div>
                        : null
                    }
                    {children}
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
            <button className="opacity-0 absolute bottom-0"></button>
          </Dialog>
        </Transition.Root>
        
      
      :
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={() => !open}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className={`fixed inset-0 bg-primarioMira ` + opacity + ` transition-opacity`} />
            </Transition.Child>

            <div className="fixed inset-0 z-30 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className={`z-30 relative transform overflow-hidden rounded-lg ${bgColor} px-4 ${paddingTop} pb-4 text-left |shadow-xl transition-all ${width}`}>
                    {
                      isDefault ?
                        <div>
                          <div className="flex justify-center">
                          <div className='w-[50%]'>
                            {image}
                          </div>
                          </div>
                          <div className="mt-3 text-center sm:mt-5">
                            <Dialog.Title as="h3" className="text-xl font-medium leading-6 text-white">
                              {title}
                            </Dialog.Title>
                            <div className="mt-2">
                              <div className="text-md text-grisMira">
                                {subtitle}
                              </div>
                              <div className="text-md text-grisMira">
                                {subtitle1}
                              </div>
                              <div className="text-md text-grisMira">
                                {subtitle2}
                              </div>
                              {subtitle3 !== ''
                                ?
                                <>
                                  <br></br>
                                  <div className="text-md text-grisMira">
                                    {subtitle3}
                                  </div>
                                </>
                                : null
                              }
                            </div>
                          </div>
                        </div>
                        : null
                    }
                    {children}
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
            <button className="opacity-0 absolute bottom-0"></button>
          </Dialog>
        </Transition.Root>
        : null
      }
    </>
  )
}
